import React from 'react'
import {
  Button, Edit, required, SaveButton, SelectInput, SimpleForm, TextInput, Toolbar,
} from 'react-admin'
import config from '../../config/config'

// Removes the delete button
const UserEditToolbar = (props) => (
  <Toolbar {...props}>
    <SaveButton />
  </Toolbar>
)

const TournamentEdit = (props) => (
  <Edit {...props}>
    <SimpleForm toolbar={<UserEditToolbar />}>
      <a href={`${config.publicWebsiteUrl}/tournois/${props.id}/export-formulaire`} target="_blank" rel="noreferrer">
        <Button label="Exporter pdf formulaire homologation" />
      </a>
      <TextInput disabled label="Nom" source="name" validate={required()} />
      <SelectInput
        label="Homologation du tournoi"
        source="certificationStatus"
        allowEmpty="false"
        choices={[
          { id: 'pendingCertification', name: 'En attente de validation' },
          { id: 'certified', name: 'Homologué' },
          { id: 'notCertified', name: 'Non homologué' },
        ]}
      />
      <SelectInput
        label="Inscriptions joueurs"
        source="registrationsStatus"
        allowEmpty="false"
        choices={[
          { id: 'opened', name: 'Ouvertes' },
          { id: 'closed', name: 'Fermées' },
        ]}
      />
      <SelectInput
        disabled
        label="Catégorie"
        source="category"
        allowEmpty="false"
        choices={[
          { id: 'french', name: 'Français' },
          { id: 'international', name: 'International' },
          { id: 'exhibition', name: 'Exhibition' },
        ]}
      />

      <TextInput disabled source="tournamentClub.league" label="Ligue" />
      <TextInput disabled source="tournamentClub.address.city" label="Ville" />
      <TextInput disabled source="tournamentClub.address.postalCode" label="Code postal" />
      <TextInput disabled source="nbRegistrations" label="Nombre d'inscriptions" />
      <SelectInput
        disabled
        label="Tableaux"
        source="tournamentClub.tables[0]"
        allowEmpty="false"
        choices={[
          { id: 'juniorTable', name: 'Tableau junior' },
          { id: 'mixedTable', name: 'Tableau mixte' },
          { id: 'menTable', name: 'Tableau hommes' },
          { id: 'quadTable', name: 'Tableau quad' },
          { id: 'franceChampionship', name: 'Championnat de France' },
        ]}
      />
      <TextInput disabled source="tournamentInfos.prizeMoney" label="Prize money" />
      <TextInput disabled source="tournamentClub.clubName" label="Nom du club" />
      <TextInput disabled source="tournamentClub.clubCode" label="Code du club" />
      <TextInput disabled source="tournamentInfos.director.lastname" label="Nom du directeur" />
      <TextInput disabled source="tournamentInfos.director.email" label="Email du directeur" />
      <TextInput disabled source="tournamentInfos.director.phoneNumber" label="Téléphone du directeur" />
      <a href={`${config.publicWebsiteUrl}/tournois/${props.id}/editer`} target="_blank" rel="noreferrer">
        <Button label="Modifier l'inscription" />
      </a>
      <a href={`${config.publicWebsiteUrl}/tournois/${props.id}/participer`} target="_blank" rel="noreferrer">
        <Button label="Inscrire un joueur à ce tournoi" />
      </a>
    </SimpleForm>
  </Edit>
)

export default TournamentEdit
